import React from 'react';
import Button from '../components/Button';
import styles from './Help.module.css';
import * as constants from '.././constants';

const Help = (props) => {

    return (
        <div className={styles.container}>
            <ul>
                <li>{constants.HELP1}</li>
                <li>{constants.HELP2}</li>
                <li>{constants.HELP3}</li>
                <li>{constants.HELP4}</li>
                <li>{constants.HELP5}</li>
            </ul>
            <div className={styles.buttons}>
                <Button onClick={() => {
                    props.changeContainer('game');
                    if (props.pausedFlag) props.startTimer(false);
                }}>{constants.TEXT11}</Button>
            </div>
        </div>
    );
}

export default Help;